import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import { ROUTE_PATHS } from "@/lib/index";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import LaVille from "@/pages/LaVille";
import ViePratique from "@/pages/ViePratique";
import Actualites from "@/pages/Actualites";
import Agenda from "@/pages/Agenda";
import CultureLoisirs from "@/pages/CultureLoisirs";
import Publications from "@/pages/Publications";
import Contact from "@/pages/Contact";
import NotFound from "./pages/not-found/Index";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <HashRouter>
        <Layout>
          <Routes>
            <Route path={ROUTE_PATHS.HOME} element={<Home />} />
            <Route path={ROUTE_PATHS.LA_VILLE} element={<LaVille />} />
            <Route path={ROUTE_PATHS.VIE_PRATIQUE} element={<ViePratique />} />
            <Route path={ROUTE_PATHS.ACTUALITES} element={<Actualites />} />
            <Route path={ROUTE_PATHS.AGENDA} element={<Agenda />} />
            <Route path={ROUTE_PATHS.CULTURE_LOISIRS} element={<CultureLoisirs />} />
            <Route path={ROUTE_PATHS.PUBLICATIONS} element={<Publications />} />
            <Route path={ROUTE_PATHS.CONTACT} element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </HashRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;